module.exports = __webpack_public_path__ + "static/media/speaker-clips.3ca4a5ad.png";